import { Avatar, Badge, Checkbox, Tooltip } from '@mantine/core';
import { IconCalendar } from '@tabler/icons-react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import styles from './LinkedTaskItem.module.scss';
import { LinkedTaskAssignee, Props } from './LinkedTaskItem.types';

const STATUS_COLOR: Record<string, string> = {
  TODO: 'orange',
  IN_PROGRESS: 'blue',
  DONE: 'teal',
};

const LinkedTaskItem = ({ item, onClick }: Props) => {
  const { t } = useTranslation();

  const status = (item.metadata?.status as string) ?? 'TODO';
  const dueDate = item.metadata?.dueDate as string | undefined;
  const assignee = (item.metadata?.assignee as LinkedTaskAssignee | null | undefined) ?? null;
  const isCompleted = status === 'DONE';

  const assigneeName = assignee
    ? `${assignee.firstName ?? ''} ${assignee.lastName ?? ''}`.trim()
    : '';
  const assigneeInitials = assignee
    ? `${assignee.firstName?.charAt(0) ?? ''}${assignee.lastName?.charAt(0) ?? ''}`.toUpperCase()
    : '';

  return (
    <div className={styles.container} onClick={onClick}>
      <div className={styles.left}>
        <Checkbox checked={isCompleted} readOnly size="md" onClick={e => e.stopPropagation()} />
        <span className={`${styles.title} ${isCompleted ? styles.completed : ''}`}>
          {item.title}
        </span>
      </div>
      <div className={styles.right}>
        {assignee && (
          <Tooltip label={assigneeName} disabled={!assigneeName} withinPortal>
            <Avatar size="sm" radius="xl" color="initials" name={assigneeInitials} />
          </Tooltip>
        )}
        {dueDate && (
          <div className={styles.dueDate}>
            <IconCalendar size={14} />
            <span>{dayjs(dueDate).format('DD/MM')}</span>
          </div>
        )}
        <Badge size="sm" color={STATUS_COLOR[status] ?? 'gray'}>
          {t(`entityLinks.task.status.${status}`, status)}
        </Badge>
      </div>
    </div>
  );
};

export default LinkedTaskItem;
